import { Skeleton } from '@mantine/core';

import type { SkeletonProps } from '../shared/helpers.ts';

/**
 * Skeleton for placeholder components during loading/streaming states.
 * Displays a simple pulsing rectangle matching the placeholder appearance.
 */
export function PlaceholderSkeleton({ height, columns: _columns, rows: _rows }: SkeletonProps) {
  return <Skeleton animate height={height ?? '100%'} radius="sm" width="100%" />;
}
